import { useContainer } from '../../useContainer';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { MeetActivity } from '../../../commonTypes/project.types';
import { useTranslation } from '../../useTranslation';

const useHttpPostMeetActivity = () => {
    const { t } = useTranslation('newNotifications');
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const execSubmit = (body: MeetActivity, callback: ICallback) => {
        const { exec, abort } = projectApi.createMeetActivity({
            body,
            onSuccess: res => {
                toastHandler.push('success', t('activity.meetActivityTitle'), t('activity.meetActivityMessage_Success'));
                if (callback.onSuccess) callback.onSuccess(res.body);
            },
            onError: _ => {
                toastHandler.push('error', t('activity.meetActivityTitle'), t('activity.meetActivityMessage_Failed'));
            },
        });

        exec();
        return abort;
    };

    return { execSubmit };
};

export default useHttpPostMeetActivity;
